module.exports = __webpack_public_path__ + "media/npc_dota_hero_abyssal_underlord.f15680b1.webm";